import React, { FC } from "react"
import { ViewMoreArrow } from "@components/Hero/styles"
import { Container } from "@components/styles"
import { scrollTo } from "@utils/scrollTo"
import { ContentHeroProps } from "./types"
import {
    BackgroundImageWrapper, ContentHeroWrapper, InnerContentWrapper, Overlay, StyledSpan
} from "./styles"

const ContentHero: FC<ContentHeroProps> = ({
    backgroundImage,
    content,
    isArticle
}) => {
    return <ContentHeroWrapper id="content-hero">
        {!!backgroundImage && <>
            <Overlay />
            <BackgroundImageWrapper>
                {backgroundImage}
            </BackgroundImageWrapper>
        </>}
        <Container css={{ zIndex: 1 }}>
            <InnerContentWrapper>
                <div dangerouslySetInnerHTML={{ __html: content }} />
            </InnerContentWrapper>
        </Container>
        {isArticle && <>
            <StyledSpan onClick={() => scrollTo("content-hero")}>
                Bekijk meer
            </StyledSpan>
            <ViewMoreArrow
                height={89}
                width={18}
                src="/icons/long-arrow-down.svg"
            />
        </>}
    </ContentHeroWrapper>
}

export default ContentHero
